const fileSizeInMegabytes = (file: any) => {
    const sizeInBytes = file.size;
    const sizeInKilobytes = sizeInBytes / 1000;
    const sizeInMegabytes = sizeInKilobytes / 1000;
    return sizeInMegabytes;
};

export const fileSizeExceedsLimit = (file: any) => {
    const fileSize = fileSizeInMegabytes(file);
    
    if (fileSize > 20) return true;
    return false;
};
